<template>
    <HeroSectionPage page_title="Sample Projects"/>
    <SampleProjects/>
    <ContactsPage/>
    </template>
    <script>
    import HeroSectionPage from '@/components/HeroSectionPage.vue';
    import ContactsPage from '@/components/ContactsPage.vue';
    import SampleProjects from '@/components/SampleProjects.vue';
    export default{
      components:{
        HeroSectionPage,
        ContactsPage,
        SampleProjects
      }
    }
    </script>